export var FUTURE_DATES = 'FUTURE_DATES';
export var PAST_DATES = 'PAST_DATES';
export var PREV_PERIOD = 'prev_period';
export var PREV_MONTH = 'prev_month';
export var PREV_YEAR = 'prev_year';